// import { OpenTabService } from './../../services/open-tab.service';
// import { RtsGatewayService } from './../../services/rts-gateway.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RtsComponent } from './rts.component';
import {
  OrdersModule,
  TabsModule,
  FilterModule,
  TableModule,
  PaginationModule,
} from 'beyond-util';

@NgModule({
  declarations: [RtsComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    TableModule,
    PaginationModule,
    OrdersModule,
  ],
  providers: [
    //      RtsGatewayService,
    //     OpenTabService
  ],
  exports: [RtsComponent],
})
export class RtsModule {}



// WEBPACK FOOTER //
// ./src/app/pages/rts/rts.module.ts